module.exports = __webpack_public_path__ + "static/background-stethoscope-8299a0bbedbd4bf119f6a3027a93b337.jpg";